import { ClientFocusValues } from "@snubes/snubes-types";

/**
 * @deprecated Use PROVIDER_CLIENT_FOCUS_RECORD instead.
 */
export const clientFocusOptions = ClientFocusValues.map((value) => ({
  id: value,
  value,
}));
